/**
 * 变压器数据统一接口
 */
const power = {
    getHPTransformerClassTree:"/api/tmp/beien/getHPTransformerClassTree",//变压器厂区树
    getTransformerInOut:"/api/tmp/beien/getTransformerInOut",//变压器投退分析
    getMonthEnergyToCharge:"/api/tmp/beien/getMonthEnergyToCharge"//月铁损节省电量对应节省费用
}

export default power;